import { useDeleteEstablishment } from "./api/deleteEstablishments";
import { Button } from "reactstrap";


const DeleteEstablishment = ({handleCloseModal, establishmentId}: DeleteEstablishmentProps)  => {
  
  const deleteEstablishmentMutation = useDeleteEstablishment({ establishmentId});
  const handleSubmit = async (): Promise<void> => {
    deleteEstablishmentMutation.mutateAsync({ 
      establishmentId: establishmentId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε το Κατάστημα;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteEstablishmentProps{
  establishmentId: number;
  handleCloseModal: () => void;
}

export default DeleteEstablishment;